import { useFormikContext } from "formik"
import { CreateUpdateMerchantFormValues } from "../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"
import React, { useState } from "react"
import { OpeningHoursAside } from "./OpeningHoursAside"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Box, Button, Typography } from "@mui/material"
import { OpeningHoursDialog } from "./OpeningHoursDialog"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    actionButton: {
        textTransform: "capitalize",
        padding: ".1rem 1.5rem",
        color: theme.palette.tailwind.sky[500],
        borderRadius: ".5rem",
    },
    asideEmptyText: {
        color: theme.palette.tailwind.zinc[500],
        fontStyle: "italic",
    },
}))

export function OpeningHoursAsideWrapper() {
    const { classes } = useStyles()

    const { values } = useFormikContext<CreateUpdateMerchantFormValues>()
    const [showOpeningHoursDialog, setShowOpeningHoursDialog] = useState(false)
    const isOpeningHoursSet = values?.openingHours && values.openingHours.length > 0

    return (
        <>
            {isOpeningHoursSet ? (
                <OpeningHoursAside weeklyScheduleData={values.openingHours} />
            ) : (
                <LocalizedStrict id="merchant-update-account-opening-hours-empty-text">
                    <Typography className={classes.asideEmptyText}>Opening hours not set</Typography>
                </LocalizedStrict>
            )}
            <Box>
                <LocalizedStrict
                    id={
                        isOpeningHoursSet
                            ? "merchant-update-account-opening-hours-action-button-edit"
                            : "merchant-update-account-opening-hours-action-button-add"
                    }
                >
                    <Button
                        onClick={() => setShowOpeningHoursDialog(true)}
                        variant="outlined"
                        size="small"
                        className={classes.actionButton}
                    >
                        {isOpeningHoursSet ? "Edit" : "Add"}
                    </Button>
                </LocalizedStrict>
            </Box>

            {showOpeningHoursDialog && (
                <OpeningHoursDialog
                    dialogState={showOpeningHoursDialog}
                    initialData={values.openingHours}
                    setDialogState={setShowOpeningHoursDialog}
                />
            )}
        </>
    )
}
